import "./Dubai.scss";
import { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { NotificationManager } from "react-notifications";
import { getPageContent } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Link } from "react-router-dom";
import Dubai1 from "../../assets/images/Dubai1.png";
import PDF from "../../assets/pdfs/CleverDomizil_UAE_v2.pdf";
import Video from "../../assets/videos/CleverDomizil_UAE_v3.mp4";
import { Tag } from "../../utils/GTMPageTag";
import { Image } from "react-bootstrap";

const Dubai = () => {
  Tag("Dubai")
  const { hostLanguage } = useLangContext();
  const [contentDetails, setContentDetails] = useState();

  // get page content
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "dubai_page_data");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  },[hostLanguage]);

  useEffect(() => {
    getAllPageContent();
  }, [getAllPageContent]);

  return (
    <div className="MainbBody UAE">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <div
                dangerouslySetInnerHTML={{
                  __html: contentDetails?.dubai_page_data?.banner_text,
                }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={Dubai1} alt="Dubai city"/>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <h3
                    dangerouslySetInnerHTML={{
                      __html:
                        contentDetails?.dubai_page_data?.section_1_heading,
                    }}
                  ></h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: contentDetails?.dubai_page_data?.section_1_body,
                    }}
                  ></p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className={"description"}>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html:
                        contentDetails?.dubai_page_data?.section_2_heading,
                    }}
                  ></h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contentDetails?.dubai_page_data?.section_2_body,
                    }}
                  ></div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="description">
                  <h3
                    dangerouslySetInnerHTML={{
                      __html:
                        contentDetails?.dubai_page_data?.section_3_heading,
                    }}
                  ></h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: contentDetails?.dubai_page_data?.section_3_body,
                    }}
                  ></p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <Link to={PDF} target={"_blank"}>
                      {contentDetails?.dubai_page_data?.button_1}
                    </Link>
                    <Link to="https://www.canva.com/design/DAGqof5ZaVc/hIU4RWjS-7QH0__ZmbHt_w/edit?utm_content=DAGqof5ZaVc&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton">
                      {contentDetails?.dubai_page_data?.button_3}
                    </Link>
                    <Link to="/kontakt">
                      {contentDetails?.dubai_page_data?.button_2}
                    </Link>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="image" style={{ backgroundColor: "#f4f4f4" }}>
                  <video className={"w-100 h-100"} controls>
                    <source src={Video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Dubai;
